// src/features/directions/directionsUtils.js

/**
 * Build a single-line address string from parts.
 * Expects an object with keys: street1, street2, city, state, zipCode
 */
export function formatAddress(address) {
  if (!address) return '';
  const street = [address.street1, address.street2].filter(Boolean).join(', ');
  const cityStateZip = [address.city, address.state, address.zipCode]
    .filter(Boolean)
    .join(' ')
    .trim();
  return [street, cityStateZip].filter(Boolean).join(', ').trim();
}

/**
 * Returns true if the address has enough information to route to.
 */
export function hasRoutableAddress(address) {
  if (!address) return false;
  // Minimal: street1, city, state OR a lat/lng pair (if later added)
  const hasPostal = Boolean(address.street1 && address.city && address.state);
  const hasCoords = Boolean(
    (typeof address.latitude === 'number' && typeof address.longitude === 'number') ||
    (typeof address.lat === 'number' && typeof address.lng === 'number')
  );
  return hasPostal || hasCoords;
}

/**
 * Build a Google Maps directions URL.
 * If coordinates are present they will be used, otherwise formatted address.
 */
export function buildDirectionsUrl({ origin, destination, travelMode = 'driving' }) {
  const serializeLocation = (loc) => {
    if (!loc) return '';
    const lat = loc.latitude ?? loc.lat;
    const lng = loc.longitude ?? loc.lng;
    if (typeof lat === 'number' && typeof lng === 'number') {
      return `${lat},${lng}`;
    }
    return formatAddress(loc);
  };

  const originStr = serializeLocation(origin);
  const destStr = serializeLocation(destination);
  if (!destStr) return '';

  const params = new URLSearchParams({ api: '1', destination: destStr, travelmode: travelMode });
  if (originStr) params.set('origin', originStr);

  return `https://www.google.com/maps/dir/?${params.toString()}`;
}



